export default __webpack_public_path__ + "media/images/plot-2-hr-690f40f1015299c651d7fa16ef797504.png";